<template>
  <VueSelecto
    ref="selecto"
    drag-container=".template-list-selection-area"
    :selectable-targets="['.template-watchfaceitem']"
    :hit-rate="0"
    :select-by-click="true"
    :select-from-inside="true"
    :ratio="0"
    :scroll-options="{
        container: frameSelectScrollContainer as HTMLDivElement,
        throttleTime: 30,
        threshold: 0
      }"
    @scroll="scrollHandler"
    @select="onFrameSelect"
  />
  <div class="template-selection relative w-0 h-0">
    <DropDown
      :trigger="'contextmenu'"
      :menus="[
        {
          title: '删除',
          onClick: () => {
            Modal.confirm({
              title: '是否删除这些模板',
              okText: '确认',
              cancelText: '取消',
              onOk: async () => {
                const _selected = Array.from(props.selected);
                while (_selected.length) {
                  const id = _selected.pop() as string;
                  await templateService.deleteTemplate(id);
                }
                emit('update', new Set());
                emit('updateTemplates');
              }
            });
          }
        },
        {
          title: '导出选中模板',
          onClick: async()=> {
            await templateService.exportTemplates([...props.selected]);
          }
        }
      ]"
    >
      <div
        class="selection-frame absolute border-[2px] border-[#0D84F2] border-solid rounded-xl"
        style="visibility: hidden"
      ></div>
    </DropDown>
  </div>
</template>
<script setup lang="ts">
import { VueSelecto } from 'vue3-selecto';
import { onMounted, ref, watch } from 'vue';
import { max, min } from 'lodash-es';
import { Modal } from 'ant-design-vue';
import { TemplateService } from '@/services/template.service';

const templateService = new TemplateService();
let selecto = ref<HTMLElement | null>(null);

const props = defineProps({
  selected: {
    type: Set<string>,
    default: new Set()
  }
});

// 监听选中变化
watch(
  () => props.selected,
  (newSelected) => {
    const selected = Array.from(
      document.querySelectorAll('.template-watchfaceitem')
    ).filter((el) =>
      newSelected.has(el.getAttribute('data-id') as string)
    ) as HTMLElement[];
    framedElements.value = selected.length > 1 ? selected : [];

    // 绘制外框
    const frameElm = document.querySelector(
      '.selection-frame'
    ) as HTMLDivElement;
    frameElm.style.visibility = framedElements.value.length
      ? 'visible'
      : 'hidden';
    if (framedElements.value.length) {
      const padding = 10;
      const frameLeft = min(
        framedElements.value.map(
          (el) => (el.parentElement as HTMLElement).offsetLeft
        )
      ) as number;
      const frameWidth =
        (max(
          framedElements.value.map(
            (el) =>
              (el.parentElement as HTMLElement).offsetLeft +
              (el.parentElement as HTMLElement).offsetWidth
          )
        ) as number) - frameLeft;
      const frameTop = min(
        framedElements.value.map(
          (el) => (el.parentElement as HTMLElement).offsetTop
        )
      ) as number;
      const frameHeight =
        (max(
          framedElements.value.map(
            (el) =>
              (el.parentElement as HTMLElement).offsetTop +
              (el.parentElement as HTMLElement).offsetHeight
          )
        ) as number) -
        frameTop -
        0;
      const selectionElm = document.querySelector(
        '.template-selection'
      ) as HTMLDivElement;
      frameElm.style.left = `${
        frameLeft - selectionElm.offsetLeft - padding
      }px`;
      frameElm.style.top = `${frameTop - selectionElm.offsetTop - padding}px`;
      frameElm.style.width = `${frameWidth + padding * 2}px`;
      frameElm.style.height = `${frameHeight + padding * 2}px`;
    }
  }
);

// 向上传值
const emit = defineEmits<{
  (event: 'update', selected: Set<string>): void;
  (event: 'updateTemplates'): void;
}>();
const framedElements = ref<HTMLElement[]>([]);

// 框选事件
const onFrameSelect = (e: { selected: HTMLElement[] }) => {
  emit(
    'update',
    new Set(e.selected.map((el) => el.getAttribute('data-id') as string))
  );
};

// 滚动事件
const scrollHandler = (e: { direction: number[] }) => {
  frameSelectScrollContainer.value?.scrollBy(
    e.direction[0] * 20,
    e.direction[1] * 20
  );
};

// 挂载时获取DOM节点
onMounted(() => {
  frameSelectScrollContainer.value = document.querySelector(
    '.frame-select-scroll-container'
  ) as HTMLDivElement;
});

let frameSelectScrollContainer = ref<HTMLDivElement | null>(null);
</script>
